module.exports = __webpack_public_path__ + "static/img/slide_6_en.e3d28c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_6_en.png
// module id = 5Evr
// module chunks = 0